// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cache-key_wrapper__xKJe0","details":"cache-key_details__Ef1By"};